import React from 'react'
import PropTypes from 'prop-types'
import { formFields } from '../constants'
import Typography from '@material-ui/core/Typography'
import Accordion from '@material-ui/core/Accordion'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'
import { isEmpty } from 'lodash'
import { HelperMsg } from '../profile.styles'

import EditFacilities from './cp-edit-facilities'
import FacilityVisibilityToggle from './facility-visibility-toggle'

const Facilities = (props) => {
  const {
    values,
    touched,
    errors,
    handleBlur,
    setFieldValue,
    setValues,
  } = props

  const FacilityAccordionSummary = withStyles({
    root: {
      flexDirection: 'row-reverse',
      padding: '10px',
      marginTop: '16px',
    },
    expandIcon: {
      marginRight: '0',
      marginLeft: '-12px',
    },
    content: {
      '&$expanded': {
        minHeight: '0',
      },
    },
    expanded: {},
  })(AccordionSummary)

  const { facilities } = values
  const { facilities: facilitiesErrors } = errors
  const { facilities: facilitiesTouched } = touched

  const handleChange = ({ target }) => {
    setFieldValue(target.name, target.value)
  }

  const setFacilityFieldValue = (field, value) => {
    setFieldValue(field, value)
  }

  const rankFacilities = (event, oldIndex, newIndex) => {
    event.stopPropagation()

    if (newIndex < 0) {
      newIndex = facilities.length + 1
    }

    const facility = facilities.splice(oldIndex, 1)
    facilities.splice(newIndex, 0, facility[0])
    facilities.forEach((facility, index) => {
      setFieldValue(`facilities[${index}].customData.facilityRank`, index + 1, false)
    })
  }

  return (
    <div key="profile-form-facilities">
      <HelperMsg>The first facility listed below is used as your location in the “Coach Search” results on PGA.com.</HelperMsg>
      {!isEmpty(facilities) && facilities.map((facility, index) => (
        <Accordion key={index}>
          <FacilityAccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Grid container>
              <Grid item xs={9}>
                <Typography>{facility.facilityName}</Typography>
              </Grid>
              <Grid item xs={1}>
                <FacilityVisibilityToggle
                  facilityIndex={index}
                  visible={facility.customData?.visible}
                  setFieldValue={setFieldValue}
                />
              </Grid>
              <Grid item xs={1}>
                <ArrowUpwardIcon onClick={(event) => { rankFacilities(event, index, index - 1) }} />
              </Grid>
              <Grid item xs={1}>
                <ArrowDownwardIcon onClick={(event) => { rankFacilities(event, index, index + 1) }} />
              </Grid>
            </Grid>
          </FacilityAccordionSummary>
          <AccordionDetails>
            <EditFacilities
              key={`facility_${index}`}
              setFieldValue={setFacilityFieldValue}
              errors={facilitiesErrors && facilitiesErrors[index]}
              handleBlur={handleBlur}
              touched={facilitiesTouched && facilitiesTouched[index]}
              formPrefix={`facilities[${index}]`}
              handleChange={handleChange}
              values={facility}
              addItems={setValues}
              facilityIndex={index}
            />
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  )
}

Facilities.propTypes = {
  values: formFields,
  touched: PropTypes.object,
  errors: PropTypes.object,
  handleBlur: PropTypes.func,
  setFieldValue: PropTypes.func,
  setValues: PropTypes.func,
}

Facilities.defaultProps = {
  values: {
    facilities: [{
      facilityName: '',
    }],
  },
}

export default Facilities
